const USE_EXTRA_PARAMS_AS_TITLE_SLUGS = ['ply-tracking-events'];
module.exports = { USE_EXTRA_PARAMS_AS_TITLE_SLUGS };
